// İSG uzmanı portalı — güvenlik ret sebebi kod → etiket eşlemesi (api-contract §29.1). İKİ
// tüketicisi var (`DayListTab.tsx`'in "Bugün" satırı VE `EntryDetailModal.tsx`'in ret bloğu,
// S32d) — `MethodMarker.tsx`'in dosya başı notundaki AYNI desen: tek yerde tanımlı, iki
// tüketici, ikinci bir sözcük dağarcığı İCAT EDİLMEDİ.
//
// Tip BİLEREK geniş (`string | null`, §29.1 kırıcı-değişiklik kuralı) — bilinmeyen/gelecekte
// eklenecek bir kod NÖTR bir yedek etikete (`security.reason.unknown.label`) düşer, ASLA bir
// izin ifadesine çözülmez ve çökmez.

const KNOWN_REASON_CODES = new Set([
  'NoPermit',
  'OutOfSite',
  'EntryNotPermitted',
  'OutOfValidity',
  'Terminal',
  'TokenExpired',
  'TokenConsumed',
]);

type TFunction = (key: string, options?: Record<string, unknown>) => string;

/** `reason` kodunu yerelleştirilmiş etikete çözer; `null`/tanınmayan kod NÖTR bir tire/etikete düşer. */
export function reasonLabel(reason: string | null, t: TFunction): string {
  if (!reason) {
    return '—';
  }
  const key = KNOWN_REASON_CODES.has(reason) ? reason : 'unknown';
  return t(`security.reason.${key}.label`);
}
